import { sendGTMEvent } from '@next/third-parties/google'
import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'
import type { GtmGlobalStoreProps } from '../../useGTM'
import { getEcommerceObjectFromProduct } from '../../helpers/getEccomerceObjectFromProduct'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'

export type GtmViewItemProps = {
  product: CosmicProductType | null
}

export const gtmViewItem = ({
  globalStore,
  product,
}: GtmGlobalStoreProps & GtmViewItemProps) => {
  if (!product) return

  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'view_item',
    event_id: uuid,
    ecommerce: getEcommerceObjectFromProduct({ globalStore, product }),
  })
}
